import styled from 'styled-components';

import { Badge } from './badge';
import { IAccentBadgeProps } from './types';

export const AccentBadge = styled(Badge)<IAccentBadgeProps>`
  color: ${Styles.color.grey.three};
  background-color: ${Styles.color.grey.five};
  margin: 4px 4px 4px 0;
  font-weight: 500;
`;
